import {useQuery} from '@tanstack/react-query';
import {BrandedContentAdsPartnership} from '@/types/brandedContentAdsPartnership';
import brandedContentAdsPartnershipFetchers from '@/api/fetchers/brandedContentAdsPartnership';

interface UseBrandedContentAdsPartnershipsQueryOptions {
  brandId: string;
  enabled?: boolean;
}

export default function useBrandedContentAdsPartnershipsQuery({
  brandId,
  enabled = true,
}: UseBrandedContentAdsPartnershipsQueryOptions) {
  return useQuery({
    queryKey: ['branded-content-ads-partnerships', brandId],
    queryFn: () =>
      brandedContentAdsPartnershipFetchers.list({
        brand_id: brandId,
        include: 'identity,profile',
      }),
    enabled: enabled && !!brandId,
    select: (response): BrandedContentAdsPartnership[] => {
      const {data} = response;
      return Array.isArray(data) ? data : [];
    },
  });
}
